import { render, staticRenderFns } from "./_collectionLayout_bedding.vue?vue&type=template&id=2571f468&scoped=true"
import script from "./_collectionLayout_bedding.vue?vue&type=script&lang=js"
export * from "./_collectionLayout_bedding.vue?vue&type=script&lang=js"
import style0 from "./_collectionLayout_bedding.vue?vue&type=style&index=0&id=2571f468&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2571f468",
  null
  
)

export default component.exports